import _ from 'underscore';
import React from 'react';
import { connect } from 'react-redux';
import Permissions from 'javascripts/analytics/config/permissions';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { HitsTable } from 'javascripts/analytics/components/hits_table';
import { PremiumHitsTableContainer } from 'javascripts/analytics/components/premium_hits_table_container';
import { OverviewTabChart } from './overview_tab_chart';
import { KeywordsHitsTable } from './../keywords_tab/keywords_hits_table';

import {
  SiteSearches,
  Hits,
  PreviousDateRangeHits,
} from 'javascripts/redux_store/analytics_dashboard/actions';

export class OverviewTabContainer extends React.Component {
  componentDidMount() {
    this.props.fetchSiteSearches();
    this.props.fetchHits();
    this.props.fetchPreviousDateRangeHits();
  }

  render() {
    return <OverviewChart {...this.props} />;
  }
}

const OverviewChart = (props) => {
  if (props.hits.models.length) {
    const internalKeywordHits =
      props.siteSearches === undefined ? [] : props.siteSearches;
    return (
      <div>
        <OverviewTabChart
          hits={props.hits.models}
          previousDateRangeHits={props.previousDateRangeHits.models}
          startDate={props.displayedDates.start}
          finishDate={props.displayedDates.finish}
          dayCount={props.displayedDates.dayCount}
        />
        <HitsTableWrapper modelsForHits={props.hits.models} />
        <InternalKeywordsTable internalKeywordHits={internalKeywordHits} />
      </div>
    );
  } else if (props.hits.models.length === 0 && props.hits.meta.fetching) {
    return (
      <div className="u-taCenter u-pv4x">
        <i className="fa fa-spin fa-spinner u-fs36"></i>
      </div>
    );
  } else if (props.hits.models.length === 0 && props.hits.meta.errorFetching) {
    return (
      <NoDataTab
        title="There was an error loading your analytics."
        details="This may have been caused by a connection issue - try reloading the page."
        loggedOutTitle={
          'There was an error loading ' +
          Aedu.User.viewed.display_name +
          "'s analytics."
        }
        noUploadButton={true}
      />
    );
  } else if (props.hits.models.length === 0) {
    return (
      <NoDataTab
        title="You haven't had any visitors recently."
        details={
          'This page shows details about visitors to your papers over the last ' +
          props.displayedDates.dayCount +
          " days. To get more visitors, make sure you've uploaded and tagged all your papers."
        }
        loggedOutTitle={
          Aedu.User.viewed.display_name + " hasn't had any visitors recently."
        }
      />
    );
  }
  return null;
};

const HitsTableWrapper = (props) => {
  if (Permissions.inMode('premium') || Permissions.inMode('upgradeable')) {
    return (
      <PremiumHitsTableContainer
        restrictData={Permissions.inMode('upgradeable')}
      />
    );
  } else if (!Permissions.inMode('restricted')) {
    return <HitsTable hits={props.modelsForHits} />;
  }

  return null;
};

const InternalKeywordsTable = (props) => {
  const internalKeywordHits = props.internalKeywordHits;
  const showInternalKeywordHits =
    (Permissions.inMode('upgradeable') || Permissions.inMode('premium')) &&
    internalKeywordHits.length > 0;
  if (!showInternalKeywordHits) {
    return null;
  }
  return (
    <KeywordsHitsTable
      hits={internalKeywordHits}
      header="Academia.edu Searches"
      showKeywords={Permissions.inMode('premium')}
      info={
        'Academia suggested your papers in ' +
        $h.numberAndNoun(internalKeywordHits.length, 'search result') +
        '.'
      }
      isShareable={false}
      showSearchEngine={false}
      showPremiumIcon={true}
      isNewFeature={new Date() < new Date('March 31, 2017')}
    />
  );
};

export const ConnectedOverviewTabContainer = connect(
  ({ AnalyticsDashboard }) => ({
    hits: AnalyticsDashboard.Hits,
    siteSearches: AnalyticsDashboard.SiteSearches,
    previousDateRangeHits: AnalyticsDashboard.PreviousDateRangeHits,
    displayedDates: AnalyticsDashboard.DisplayedDates,
  }),
  {
    fetchSiteSearches: SiteSearches.fetch,
    fetchHits: Hits.fetch,
    fetchPreviousDateRangeHits: PreviousDateRangeHits.fetch,
  },
)(OverviewTabContainer);
